<div class="user-change-password">
  <div class="title">{{ "MENU.CHANGE_PASSWORD" | translate }}</div>
  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <input class="d-none" [value]="email" autocomplete="username" />
    <div class="form-group mb-1">
      <app-form-input-reactive
        [autofocus]="true"
        [inputType]="'password'"
        [label]="'INPUT.OLD_PASSWORD.LABEL'"
        [placeholder]="'INPUT.DEFAULT.PLACEHOLDER'"
        [control]="formCurrentPassword"
        [errors]="formError.currentPassword"
        [autocomplete]="'current-password'"
        (modelChange)="clearErrors()"
        [attr.data-cy]="'currentPassword'"
      >
      </app-form-input-reactive>
    </div>
    <div class="form-group mb-1">
      <app-password-input
        [password]="formNewPassword.value"
        (passwordChange)="formNewPassword.setValue($event)"
        [(isValidated)]="isPasswordValidated"
        [isBusiness]="isBusiness"
        [isTaxAdviser]="isTaxAdviser"
        [isSubaccount]="isSubaccount"
        [isMaster]="isMaster"
      >
      </app-password-input>
    </div>
    <div class="form-group mb-1_5">
      <app-form-input-reactive
        [inputType]="'password'"
        [label]="'INPUT.NEW_PASSWORD_REPEAT.LABEL'"
        [placeholder]="'INPUT.DEFAULT.PLACEHOLDER'"
        [control]="formNewPasswordRepeat"
        [errors]="formError.newPasswordRepeat"
        [autocomplete]="'new-password'"
        (modelChange)="clearErrors()"
        [attr.data-cy]="'newPasswordRepeat'"
        [appShowPassword]="true"
      >
      </app-form-input-reactive>
    </div>
    <div>
      @if (errors?.non_field_errors?.length) {
        <div class="alert-box">
          {{ errors.non_field_errors[0] }}
        </div>
      }
      @if (errors?.non_field_errors?.length) {
        <div class="alert-box">{{ errors.non_field_errors[0] }}</div>
      }
      @if (errors?.uid?.length) {
        <div class="alert-box">{{ errors.uid[0] }}</div>
      }
      @if (errors?.token?.length) {
        <div class="alert-box">{{ errors.token[0] }}</div>
      }
    </div>
    <div class="d-flex justify-content-end">
      <button
        class="btn btn--primary"
        type="submit"
        [disabled]="isFormLoading || !email"
        [class.is-loading]="isFormLoading"
      >
        {{ "COMMON.SAVE" | translate }}
      </button>
    </div>
  </form>
</div>
